export default __webpack_public_path__ + "static/tiger-face-fd025a5168eeb290c86b7872c7ccb818.webp";